var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"e-footer"},[_c('supporters',{staticClass:"e-footer__supporters"}),_c('span',{staticClass:"e-brand-name"},[_c('Logo',{staticClass:"e-brand-name--white",attrs:{"aria-label":"Logo"}}),_c('LogoOrig',{staticClass:"e-brand-name--orig e-tablet-hidden",attrs:{"aria-label":"Logo"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }